import { ThemeVariants } from '@stripcash/ui-kit/hoc/Theme';
import SunIcon from '@stripcash/ui-kit/icons/sun.svg';
import MoonIcon from '@stripcash/ui-kit/icons/moon.svg';
import { AnimatePresence, motion } from 'motion/react';

import s from './styles.module.css';

const ThemeButton = ({ onClick, currentTheme }) => (
  <motion.button
    type="button"
    className={s.themeButtonWrapper}
    onClick={onClick}
    whileHover={{ rotate: -180 }}
  >
    <AnimatePresence initial={false} mode="wait">
      <motion.span
        key={currentTheme === ThemeVariants.Dark ? 'moon' : 'sun'}
        initial={{
          y: currentTheme === ThemeVariants.Dark ? -20 : 20,
          opacity: 0,
        }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: currentTheme === ThemeVariants.Dark ? 20 : -20, opacity: 0 }}
        transition={{ type: 'tween', duration: 0.12 }}
        className={s.themeButton}
      >
        {currentTheme === ThemeVariants.Dark ? (
          <MoonIcon size={17} />
        ) : (
          <SunIcon size={17} />
        )}
      </motion.span>
    </AnimatePresence>
  </motion.button>
);

export default ThemeButton;
